import React from 'react';
import styled from '../../../libs/styled.es.js';
import { iconMap } from './icons.es.js';
import { space } from 'styled-system';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledSvgIcon = styled.i(space, ({ imageUrl, color, theme, size }) => `
  width: ${size || 50}px;
  height: ${size || 50}px;
  background-color: var(--button-icon-color, ${color || theme.colors.gray600});
  background: url("${imageUrl}");
  display: inline-block;
  background-repeat: no-repeat;
  background-position: center;
`);
const Icon = (_a) => {
  var _b = _a, {
    name
  } = _b, props = __objRest(_b, [
    "name"
  ]);
  const imageUrl = iconMap[name];
  if (!imageUrl) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(StyledSvgIcon, __spreadValues({
    imageUrl
  }, props));
};

export { Icon };
